import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function DeletePosRoleDialog(props) {
    const { assignedUsersCount, posRole, onDelete, onCancel } = props;

    return (
        <Dialog closeIcon={false} width={350} title={assignedUsersCount > 0 ? "Cannot Delete" : "Delete"}>
            {assignedUsersCount > 0 ? <p style={{ margin: "25px", textAlign: "center" }}>
                The POS role {posRole.name} cannot be deleted.<br />
                It is assigned to {assignedUsersCount} user(s)<br />
                Please remove the assignments before deleting the POS role
            </p> :
                <p style={{ margin: "25px", textAlign: "center" }}>
                    Are you sure you want to delete the POS role {posRole.name}?
                </p>}
            {assignedUsersCount > 0 && (
                <DialogActionsBar>
                    <button onClick={onCancel} className="k-button k-button-primary" aria-label="ok button of delete dialog">
                        OK
                    </button>
                </DialogActionsBar>
            )}
            {assignedUsersCount == 0 && (
                <DialogActionsBar>
                    <button onClick={() => onDelete(posRole)} className="k-button k-button-primary" aria-label="yes button of delete dialog">
                        Yes
                    </button>
                    <button onClick={onCancel} className="k-button" aria-label="no button of delete dialog">
                        No
                    </button>
                </DialogActionsBar>
            )}
        </Dialog>
    );
}